<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">

              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">¿Olvidaste tu Contraseña?</h4>
                  <p class="mb-0">Introduce tu correo electrónico para recibir un enlace de restablecimiento.</p>
                </div>

                <div class="card-body">
                  <form @submit.prevent="requestPasswordReset" >
                    <div class="mb-3">
                      <argon-input
                        type="email"
                        placeholder="Correo Electrónico Registrado"
                        name="email"
                        size="lg"
                        v-model="email"
                        required
                      />
                    </div>

                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4"
                        color="primary"
                        fullWidth
                        size="lg"
                      >Solicitar Enlace de Restablecimiento</argon-button>
                    </div>
                  </form>
                </div>

                <div class="card-footer text-center pt-0 px-lg-2 px-1">
                    <p class="mb-4 text-sm mx-auto">
                        ¿Recordaste tu contraseña?
                        <router-link :to="{ name: 'Signin' }" class="text-primary font-weight-bold">
                            Volver al Login
                        </router-link>
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "@/assets/img/logo.png";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "ForgotPasswordRequest",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      logo,
      email: null,
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    requestPasswordReset() {
      let self = this;

      if (!this.email || !this.email.includes('@')) {
        Swal.fire({
          title: 'Error',
          text: 'Por favor, introduce un correo electrónico válido.',
          icon: 'warning',
          confirmButtonColor: '#bf4f51',
        });
        return;
      }

      const requestData = {
        email: this.email,
        // Puedes añadir aquí la URL base de tu frontend si el backend la necesita
        // frontend_url: window.location.origin + '/#/password/reset'
      };

      // 🛑 ENDPOINT SOLICITADO: /password/request 🛑
      axios.post(self.$store.state.apiURL + 'password/request', requestData)
        .then(() => {
          // ÉXITO: Solicitud enviada
          Swal.fire({
            title: '¡Enlace Enviado!',
            html: `Hemos enviado un enlace de restablecimiento a <b>${this.email}</b>.<br>Por favor, revisa tu bandeja de entrada y spam.`,
            icon: 'success',
            confirmButtonText: 'Entendido',
          }).then(() => {
             // Opcional: Redirigir al inicio de sesión o a una página de confirmación
             self.$router.push('/signin');
          });
        })
        .catch((err) => {
          console.error("Fallo de solicitud de restablecimiento:", err);
          let errorMessage = 'No pudimos procesar tu solicitud. Asegúrate de que el correo electrónico sea correcto.';

          if (err.response && err.response.status === 404) {
             errorMessage = 'El correo electrónico no se encuentra registrado.';
          } else if (err.response && err.response.data && err.response.data.message) {
             errorMessage = err.response.data.message;
          }

          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonColor: '#bf4f51',
          });
        });
    }
  }
};
</script>

<style scoped>
/* Estilos específicos si son necesarios */
</style>